<template>
  <div>
    <div class="text-center mt-5">
      <h5 v-if="erro" class="text-danger mb-4"><small>Erro ao salvar</small></h5>
      <h5>Conta Pix</h5>
      <div class="d-flex justify-content-center">
        <Combo :itens="accountsArr" style="max-width: 700px;" v-model="item.defaultPix" />
      </div>
      <button type="button" class="btn btn-lg btn-warning mt-5" @click="salvarConfig()">
        Salvar
      </button>
    </div>
  </div>
</template>

<script>
import { api } from "@/services/api.js";
//import util from "../includes/util.js";

import Combo from "../components/Combo.vue";

export default {
  name: "AdminConfig",
  components: { Combo },
  props: {

  },
  data: function () {
    return {
      accounts: {},
      accountsArr: [],
      item: {
        defaultPix: ""
      },
      erro: false
    };
  },
  methods: {
    async salvarConfig() {

      try {

        this.erro = false;

        let result = await api.post("/config", this.item);

        if (result.data && result.data.erro == false) {

          this.erro = false;

        } else {
          this.erro = true;
        }

      } catch (err) {
        this.erro = true;
      }

    },
    async carregarItem() {

      try {

        this.erro = false;

        let result = await api.get("/config");

        if (result.data.erro == false && result.data.item) {
          
          this.item.defaultPix = result.data.item.defaultPix;

        }

      } catch (err) {
        console.log(err);
      }

    },
    async carregarAccounts() {

      try {

        this.erro = false;

        this.accountsArr.push({id:"", nome:"Selecione..."});

        let result = await api.get("/config/accounts");

        if (result.data.erro == false && result.data.accounts) {
          this.accounts = result.data.accounts;

          let accountsKeys = Object.keys(this.accounts);

          for (let i = 0; i < accountsKeys.length; i++) {
            let item = this.accounts[accountsKeys[i]];
            this.accountsArr.push({ ...item, id: accountsKeys[i], nome: item.info });
          }

        }

      } catch (err) {
        console.log(err);
      }

    }
  },
  mounted() {

    this.carregarAccounts();
    this.carregarItem();

  },
  computed: {

  },
};
</script>

<style></style>
